module.exports = __webpack_public_path__ + "static/media/search-audience.590dca94.svg";